/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/Search.css'

/**
 *     Import
 *     - Components
 */

/**
 *     Import
 *     - Images
 */
import { SearchIcon } from '../../../images/icons/Search/Search'

export default class Search extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {

        }
    }

    render() {
        return (
            <div className="searchNav">
                <div className="searchNav__button">
                    <SearchIcon />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Search/Search.tsx